'use strict';

angular.module('mainController', [])
.controller('MainController', ['$scope', '$rootScope', 'Modernizr', '$window', '$location'
    ,function ($scope, $rootScope, Modernizr, $window, $location) {

    $rootScope.header = {};
    $rootScope.header.show = true;

    $rootScope.browser = {
        supportNumberInput: Modernizr.inputtypes.number
        ,touchSupport: Modernizr.touchevents
    };

    // $scope.ucwords = function (str) {
    //     return (str + '').replace(/^([a-z])|\s+([a-z])/g, function ($1) { return $1.toUpperCase();  });
    // };

    $scope.isArray = function(arr) {
        return arr.constructor.toString().indexOf("Array") > -1;
    };

    // simple js index.of function
    $scope.inArray = function(arr, obj) {
        for(var i=0; i<arr.length; i++) {
            if (arr[i] == obj) return true;
        }
    }

    $scope.openAgency = function(identifier){
        $location.path('/agency/'+identifier);
    }

    $scope.findWithAttr = function(array, attr, value) {
        for(var i = 0; i < array.length; i += 1) {
            if(array[i][attr] === value) {
                return i;
            }
        }
    };

    
}]);